import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'components/common';
import { FaTimes, FaChevronRight } from 'react-icons/fa';
import TopicHeader from './TopicHeader';
import TopicCard from './TopicCard';

const InteractionDetailModal = ({ open, setOpen, topic }) => (
  <Drawer
    show={open}
    onHide={() => setOpen(false)}
    placement="right"
    width="min(62%, 900px)"
  >
    <div className="-tw-mx-6 -tw-my-5 tw-flex tw-flex-col tw-min-h-full">
      {/* ── Thin nav bar ────────────────────────────────────────── */}
      <div
        className="tw-sticky tw-top-0 tw-z-10"
        style={{
          display: 'flex', alignItems: 'center',
          height: 44, padding: '0 16px', flexShrink: 0,
          background: 'linear-gradient(135deg, #1e3a5f 0%, #1d4ed8 100%)',
        }}
      >
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
          <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 11, whiteSpace: 'nowrap' }}>Interactions</span>
          <FaChevronRight size={8} style={{ color: 'rgba(255,255,255,0.35)', flexShrink: 0 }} />
          <span style={{
            color: '#fff', fontSize: 12, fontWeight: 600,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {topic?.project?.name || '—'}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setOpen(false)}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 28, height: 28, borderRadius: 6, border: 'none',
            background: 'rgba(255,255,255,0.12)', color: '#fff',
            cursor: 'pointer', flexShrink: 0,
          }}
          aria-label="Close"
        >
          <FaTimes size={11} />
        </button>
      </div>

      {/* ── Scrollable body ─────────────────────────────────────── */}
      <div style={{ background: '#f1f5f9', flex: 1 }}>
        {/* Topic header: title, badges, author, actions */}
        <TopicHeader topic={topic} />

        {/* Divider */}
        <div style={{ height: 1, background: '#e2e8f0', margin: '0 20px' }} />

        {/* Description, buildings, responses */}
        <TopicCard topic={topic} />
      </div>
    </div>
  </Drawer>
);

InteractionDetailModal.propTypes = {
  open:    PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  topic:   PropTypes.object,
};

export default InteractionDetailModal;
